export class TransportCreationProfileSight {

  id: number;
  name: string;

  constructor(profile?: any) {
      if (profile != null) {
          this.id = profile.id;
          this.name = profile.name;
      }
  }
}
